export const getMarketsCountLinkProps = (details, componentPrefix) => {
    return {
        linkUrl: details.event.linkUrl,
        componentPrefix,
        marketsCount: details.event.totalMarketsCount,
        isInFavorites: details.event.isInFavorites,
        isFavoritesEnabled: details.isFavoritesEnabled,
        favoritesHandler: details.handlers.favorites,
        eventCardHandler: details.handlers.eventCard,
    };
};
//# sourceMappingURL=getMarketsCountLinkProps.js.map